import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { streckenTarifierungVmRS } from './streckenTarifierungVmRS';
import { shopTarifierungVmRS } from './shopTarifierungVmRS';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { watchDruckdatenRequested } from './druckdatenSaga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchRechtsstreitigkeitenChangedSaga } from './resetSelbstbehaltSaga';
import { handleRsVermietungNavigationToAngebotSaga } from './handleRsVermietungNavigationToAngebotSaga';
import { watchQuoteDB } from './quoteDbSaga';

export function* rootSaga() {
  yield all([
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    streckenTarifierungVmRS(),
    shopTarifierungVmRS(),
    watchInDashboardUebernehmenSaga(),
    watchAntragsnummerRequested(),
    watchVorbelegungRequested(),
    watchDruckdatenRequested(),
    watchVorschlagdatenChanged(),
    watchRechtsstreitigkeitenChangedSaga(),
    handleRsVermietungNavigationToAngebotSaga(),
    watchQuoteDB(),
  ]);
}
